function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, Stack, FontIcon, mergeStyleSets } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
const closeButtonText = 'Done';
const iconName = 'Completed';
const modalMinWidth = '560px';
const modalProps = {
    isDarkOverlay: false
};
const stackTokens = {
    childrenGap: 8
};
const classNames = mergeStyleSets({
    icon: [
        {
            fontSize: 16,
            height: 16,
            width: 16,
            color: '#107C10',
            marginTop: 2
        }
    ]
});
const dialogStyles = {
    main: {
        minHeight: 100
    }
};
const dialogContentStyles = {
    header: {
        color: NeutralColors.gray160
    }
};
const dialogContentProps = (context)=>{
    return {
        type: DialogType.close,
        closeButtonAriaLabel: context.loc('SubmittedModal_CloseButton_AriaText', 'Close'),
        styles: dialogContentStyles
    };
};
export const SubmittedModal = ({ hidden, onDismiss, title, children, context })=>{
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: hidden,
        dialogContentProps: _object_spread_props(_object_spread({}, dialogContentProps(context)), {
            title
        }),
        minWidth: modalMinWidth,
        modalProps: modalProps,
        styles: dialogStyles,
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: stackTokens,
                children: [
                    /*#__PURE__*/ _jsx(FontIcon, {
                        iconName: iconName,
                        className: classNames.icon
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    text: context.loc('SubmittedModal_CloseButton_Text', closeButtonText),
                    onClick: onDismiss
                })
            })
        ]
    });
};
